import parsePhoneNumber from 'libphonenumber-js';
import Typewriter from 'typewriter-effect/dist/core';

// Libs validation tel et écriture machine à écrire
window.phone = parsePhoneNumber;
window.Typewriter = Typewriter;

const htmlLang = document.documentElement.lang || 'fr-FR';
const languageCode = htmlLang.split('-')[0];

let currentLanguage = 'fr';

if (languageCode === 'en') {
    currentLanguage = 'en';
}

let devisElement = document.querySelector('.elt_typecontact.devis');

// Encapsulation de l'état de la session de chat
let chatSessionState = {
    isActive: true,
    sendForm: false,
    currentStep: 0
};

const form = document.querySelector("#wpcf7-f741-o1 form");
const chatOutput = document.getElementById('chat-window');
const chatInput = document.getElementById('user-input');
const sendButton = document.getElementById('send-button');
const loadingElement = document.getElementById('chargement');

// Traductions
const translations = {
    fr: {
        thanks: 'Merci',
        sessionEnded: "Votre session est terminée, n'hésitez pas à rafraîchir la page si vous souhaitez en relancer une nouvelle.",
        thankYou: "Un grand merci d'avoir pris contact avec C. Concept. Un de mes collègues assurera le suivi de votre demande dans les meilleurs délais. Très belle journée à vous ! Sébastien.",
        rgpd: "Je vais vous demander vos coordonnées, celles-ci seront exclusivement et uniquement utilisées par notre agence et dans le respect de la RGPD.",
        submissionInProgress: "⏳ Soumission en cours, veuillez patienter...",
        confirmationSent: "💌 Une confirmation vous a été envoyée.",
        submissionError: "❌ Une erreur s'est produite : ",
        sessionEndedFinal: "🏁 Votre session est terminée.",
        errorMessages: {
            name: "❌ Le nom et prénom ne peuvent pas être vides et doivent être valides. Veuillez réessayer.",
            subject: "❌ Vous devez saisir votre demande avant de continuer. Veuillez réessayer.",
            message: "❌ La réponse ne peut pas être vide. Veuillez réessayer.",
            website: "❌ L'URL fournie n'est pas valide. Veuillez entrer une URL valide (ex: https://www.exemple.com).",
            entreprise: "❌ Veuillez saisir le nom de votre entité, ABSL avant de continuer. Veuillez réessayer.",
            email: "❌ L'e-mail fourni n'est pas valide. Veuillez entrer une adresse e-mail valide.",
            tel: "❌ Le numéro de téléphone fourni n'est pas valide. Veuillez réessayer (n'oubliez pas l'indicatif).",
            creneau: "❌ Merci de préciser votre plage horaire avant de continuer. Veuillez réessayer.",
            commentaire: "❌ Le commentaire ne peut pas être vide. Veuillez réessayer."
        },
        stepQuestions: [
            "Bonjour, je m'appelle Sébastien. Puis-je vous demander vos nom et prénom ?",
            "Quelle est votre demande, votre projet... Comment puis-je vous aider ?",
            "Souhaitez-vous ajouter quelque chose ? Plus vous serez précis, et plus la réponse sera pertinente.",
            "Quelle est l'adresse de votre site internet ?",
            "Le nom de votre entité, entreprise ou asbl",
            "Votre e-mail",
            "Votre numéro de téléphone (avec indicatif, ex: +352)",
            "Avez-vous une plage horaire que vous préférez afin que nous puissions vous recontacter à ce numéro ?",
            "Un commentaire complémentaire ?"
        ]
    },
    en: {
        thanks: 'Thank you',
        sessionEnded: "Your session has ended. Feel free to refresh the page if you wish to start a new one.",
        thankYou: "Thank you very much for contacting C. Concept. One of my colleagues will follow up on your request as soon as possible. Have a great day! Sébastien.",
        rgpd: "I will ask for your contact details, which will be used exclusively and solely by our agency and in compliance with GDPR.",
        submissionInProgress: "⏳ Submission in progress, please wait...",
        confirmationSent: "💌 A confirmation has been sent to you.",
        submissionError: "❌ An error occurred: ",
        sessionEndedFinal: "🏁 Your session has ended.",
        errorMessages: {
            name: "❌ Name and surname cannot be empty and must be valid. Please try again.",
            subject: "❌ You must enter your request before continuing. Please try again.",
            message: "❌ The response cannot be empty. Please try again.",
            website: "❌ The provided URL is not valid. Please enter a valid URL (e.g., https://www.example.com).",
            entreprise: "❌ Please enter the name of your entity, company, or association before continuing. Please try again.",
            email: "❌ The provided email is not valid. Please enter a valid email address.",
            tel: "❌ The provided phone number is not valid. Please try again (don't forget the country code).",
            creneau: "❌ Please specify your preferred time slot before continuing. Please try again.",
            commentaire: "❌ The comment cannot be empty. Please try again."
        },
        stepQuestions: [
            "Hello, my name is Sébastien. May I ask for your first and last name?",
            "What is your request, your project... How can I assist you?",
            "Would you like to add something? The more precise you are, the more relevant the response will be.",
            "What is the address of your website?",
            "The name of your entity, company, or association",
            "Your email",
            "Your phone number (with country code, e.g., +352)",
            "Do you have a preferred time slot for us to contact you at this number?",
            "Any additional comments?"
        ]
    }
};

// Fonction pour chopper la bonne clé de traduction et les messages associés
function t(key) {
    if (translations[currentLanguage] && translations[currentLanguage][key]) {
        return translations[currentLanguage][key];
    }
    return key;
}

// Fonction de délai via promise (timeout trop lourd...)
function delay(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

// Fonction de sanitation des réponses user
function sanitizeInput(input) {
    const temp = document.createElement('div');
    temp.textContent = input;
    return temp.innerHTML;
}

// Fonctions de validation
function validatePhoneNumber(phoneNumber) {
    let phone = parsePhoneNumber(phoneNumber);
    return phone ? phone.isValid() : false;
}

function validateEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
}

function validateName(name) {
    const nameRegex = /^[A-Za-zÀ-ÿ\s'-]{2,50}$/;
    return nameRegex.test(name);
}

function validateSubject(subject) {
    const subjectRegex = /^[A-Za-zÀ-ÿ0-9\s',.-]{2,100}$/;
    return subjectRegex.test(subject);
}

function validateUrl(url) {
    const regex = /^(https?:\/\/)?(www\.)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/.*)?$/;
    return regex.test(url);
}

let chatSteps = [
    {
        question: translations[currentLanguage].stepQuestions[0],
        field: "input[name='nom']",
        response: (name) => `${translations[currentLanguage].thanks} ${sanitizeInput(name)}! ${translations[currentLanguage].stepQuestions[1]}`,
        validate: validateName,
        errorMessage: translations[currentLanguage].errorMessages.name
    },
    {
        question: translations[currentLanguage].stepQuestions[1],
        field: "input[name='sujet']",
        response: () => translations[currentLanguage].stepQuestions[2],
        validate: validateSubject,
        errorMessage: translations[currentLanguage].errorMessages.subject
    },
    {
        question: translations[currentLanguage].stepQuestions[2],
        field: "textarea[name='message']",
        response: (message) => {
            if (currentLanguage === 'fr') {
                if (message.toLowerCase() === "non" || message.length === 0) {
                    return translations[currentLanguage].stepQuestions[3];
                }
                return translations[currentLanguage].stepQuestions[3];
            } else if (currentLanguage === 'en') {
                if (message.toLowerCase() === "no" || message.length === 0) {
                    return translations[currentLanguage].stepQuestions[3];
                }
                return translations[currentLanguage].stepQuestions[3];
            }
            return translations[currentLanguage].stepQuestions[3];
        },
        validate: () => true,
        errorMessage: translations[currentLanguage].errorMessages.message
    },
    {
        question: translations[currentLanguage].stepQuestions[3],
        field: "input[name='website']",
        response: () => translations[currentLanguage].stepQuestions[4],
        validate: validateUrl,
        errorMessage: translations[currentLanguage].errorMessages.website
    },
    {
        question: translations[currentLanguage].stepQuestions[4],
        field: "input[name='entreprise']",
        response: () => translations[currentLanguage].stepQuestions[5],
        validate: (answer) => answer.length > 0,
        errorMessage: translations[currentLanguage].errorMessages.entreprise
    },
    {
        question: translations[currentLanguage].stepQuestions[5],
        field: "input[name='email']",
        response: () => translations[currentLanguage].stepQuestions[6],
        validate: validateEmail,
        errorMessage: translations[currentLanguage].errorMessages.email
    },
    {
        question: translations[currentLanguage].stepQuestions[6],
        field: "input[name='tel']",
        response: (tel) => {
            if ((currentLanguage === 'fr' && (tel.toLowerCase() === "non" || tel.length === 0)) ||
                (currentLanguage === 'en' && (tel.toLowerCase() === "no" || tel.length === 0))) {
                return translations[currentLanguage].stepQuestions[8];
            } else if (validatePhoneNumber(tel)) {
                return translations[currentLanguage].stepQuestions[7];
            }
            return false;
        },
        validate: () => true,
        errorMessage: translations[currentLanguage].errorMessages.tel
    },
    {
        question: translations[currentLanguage].stepQuestions[7],
        field: "input[name='creneau']",
        response: () => translations[currentLanguage].stepQuestions[8],
        validate: (answer) => answer.length > 0,
        errorMessage: translations[currentLanguage].errorMessages.creneau
    },
    {
        question: translations[currentLanguage].stepQuestions[8],
        field: "textarea[name='commentaire']",
        response: () => {
            chatSessionState.isActive = false;
            chatSessionState.sendForm = true;
            return null; // Pas de message de réponse
        },
        validate: () => true,
        errorMessage: translations[currentLanguage].errorMessages.commentaire
    }
];


// Fonction principale pour gérer les étapes du chat
async function handleNextStep() {
    if (!chatSessionState.isActive) {
        showLoading();
        await delay(1000);
        hideLoading();
        appendToChat('bot-message', t('sessionEnded'));
        return;
    }

    let currentChatStep = chatSteps[chatSessionState.currentStep];
    let field = document.querySelector(currentChatStep.field);
    let answer = chatInput.value.trim();

    // Validation étape
    if (currentChatStep.validate && !currentChatStep.validate(answer)) {
        appendToChat('info-message', currentChatStep.errorMessage || `❌ La réponse donnée n'est pas valide. Veuillez réessayer.`);
        return;
    }

    if (answer) {
        appendToChat('user-message', sanitizeInput(answer));
    }

    let botResponse = currentChatStep.response(answer);

    if (botResponse === false) {
        appendToChat('info-message', currentChatStep.errorMessage || `❌ La réponse donnée n'est pas valide. Veuillez réessayer.`);
        return;
    }

    // Enregistrement de la réponse dans le champ du formulaire, si ce n'est pas la dernière étape ou une réponse négative
    if (field && (chatSessionState.currentStep !== chatSteps.length - 1 || (answer.toLowerCase() !== "non" && answer.length > 0))) {
        field.value = sanitizeInput(answer);
    }

    // Gestion du message RGPD pour le champ "message"
    if (field && field.name === "message") {
        showLoading();
        await delay(1000);
        hideLoading();
        appendToChat('bot-message', t('rgpd'));

        document.addEventListener('messageCompleted', () => {
            const acceptanceField = document.querySelector('input[name="acceptance"]');
            if (acceptanceField) {
                acceptanceField.checked = true;
            }
            displayNextQuestion(botResponse);
            chatSessionState.currentStep++;
            chatInput.value = "";
        }, { once: true });

    } else if (chatSessionState.currentStep === chatSteps.length - 1) {
        // Dernière étape
        chatSessionState.isActive = false;
        chatSessionState.sendForm = true;
        appendToChat('bot-message', t('thankYou'));

        document.addEventListener('messageCompleted', () => {
            sendFormAJAX();
        }, { once: true });

    } else {
        // Passer à l'étape suivante
        displayNextQuestion(botResponse).catch(error => {
            console.error('Erreur lors du traitement de la question suivante :', error);
        });
        chatSessionState.currentStep++;
        chatInput.value = "";
    }

}

async function displayNextQuestion(question) {
    showLoading();
    await delay(1000);
    hideLoading();
    if(question !== undefined && question !== null) {
        appendToChat('bot-message', sanitizeInput(question));
    }
}

function appendToChat(type = 'user-message', text) {
    let message = document.createElement('div');
    let chatInputArea = document.querySelector('#input-area');
    message.classList.add('message');

    if (type === 'bot-message') {
        chatInputArea.classList.add('is-disabled');
        chatInput.disabled = true;
        message.classList.add('bot-message');
        chatOutput.appendChild(message);
        chatOutput.scrollTop = chatOutput.scrollHeight;

        const typewriter = new Typewriter(message, {
            loop: false,
            delay: 25,
        });

        // Simulation des fautes de frappe
        const words = text.split(' ');
        words.forEach((word, index) => {
            // Ici on essaye de vérifier les mots de plus de 3 lettres et d'ajouter un caractère aléatoire avec 5% de chances
            if (Math.random() < 0.05 && word.length > 3) {
                const typoIndex = Math.floor(Math.random() * word.length);
                const typoChar = String.fromCharCode(97 + Math.floor(Math.random() * 26));
                const wrongWord = word.substring(0, typoIndex) + typoChar + word.substring(typoIndex + 1);

                typewriter
                    .typeString(wrongWord + ' ')
                    .pauseFor(500)
                    .deleteChars(word.length + 1)
                    .typeString(word + ' ');
            } else {
                typewriter.typeString(word + ' ');
            }
        });

        typewriter.callFunction(() => {
            const caret = message.querySelector('.Typewriter__cursor');
            if (caret) {
                caret.style.display = 'none';
                const event = new CustomEvent('messageCompleted');
                document.dispatchEvent(event);
            }

            chatInputArea.classList.remove('is-disabled');
            chatInput.disabled = false;
            chatInput.focus();
        }).start();
    } else {
        if (type === 'user-message') {
            message.classList.add('user-message');
        } else if (type === 'info-message') {
            message.classList.add('info-message');
        }
        message.textContent = text;
        chatOutput.appendChild(message);
        chatOutput.scrollTop = chatOutput.scrollHeight;
    }
}

function showLoading() {
    loadingElement.classList.add('is-loading');
}

function hideLoading() {
    loadingElement.classList.remove('is-loading');
}

// Fonction pour envoyer le formulaire via AJAX
async function sendFormAJAX() {
    const formData = new FormData(form);
    let chatInputArea = document.querySelector('#input-area');
    chatInputArea.classList.add('is-disabled');
    chatInput.disabled = true;

    formData.append('_wpnonce', wpAjax.nonce);
    formData.append('action', 'submit_contact_form');

    appendToChat('info-message', t('submissionInProgress'));

    try {
        const response = await fetch(wpAjax.ajax_url, {
            method: 'POST',
            body: formData,
            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            }
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const jsonResponse = await response.json();

        if (jsonResponse.success) {
            appendToChat('info-message', t('confirmationSent'));
            let mailSentEvent = new CustomEvent('wpcf7mailsent', {
                'detail' : {
                    'contactFormId' : 'chatbot',
                    'inputs': 'ok',
                },
            })
            document.dispatchEvent(mailSentEvent)

        } else {
            appendToChat('info-message', `❌ ${sanitizeInput(jsonResponse.data.message)}`);
        }

    } catch (error) {
        chatInputArea.classList.remove('is-disabled');
        chatInput.disabled = false;
        appendToChat('info-message', `${t('submissionError')}${sanitizeInput(error.message)}`);
    }
    appendToChat('info-message', t('sessionEndedFinal'));
    chatInputArea.classList.remove('is-disabled');
    chatInput.disabled = false;
}

function initializeChat() {
    displayNextQuestion(chatSteps[chatSessionState.currentStep].question).catch(error => {
        console.error('Erreur lors du traitement de la question suivante :', error);
    });
}

function observeClassChanges(element) {
    const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.attributeName === 'class') {
                const hasActiveClass = element.classList.contains('active');

                if (hasActiveClass && chatSessionState.currentStep === 0) {
                    initializeChat();
                }
            }
        });
    });

    observer.observe(element, { attributes: true });

    // Vérifie si l'élément a déjà la classe .active au chargement de la page
    if (element.classList.contains('active') && chatSessionState.currentStep === 0) {
        initializeChat();
    }
}

if (devisElement) {
    observeClassChanges(devisElement);
}

sendButton.addEventListener('click', handleNextStep);
chatInput.addEventListener('keypress', function (e) {
    if (e.key === 'Enter') {
        handleNextStep().catch(error => {
            console.error('Erreur lors du traitement de l\'étape suivante :', error);
        });
    }
});
